import React from 'react';
import { Switch, Route } from 'react-router-dom';
import DrumsPage from './DrumsPage';
// import FreeLessonsPage from './FreeLessonsPage';
import HomePage from './HomePage';
import LessonsPage from './LessonsPage';
import LoginPage from './LoginPage';
import ProAudioPage from './ProAudioPage';
// import ProductListPage from './ProductListPage';
// import ProductPage from './ProductPage';
import RepairPage from './RepairPage';
import RoadShowPage from './RoadShowPage';
import StoreInfoPage from './StoreInfoPage';

const App = () => (
  <div style={{ height: '100%', width: '100%' }}>
    <Switch>
      <Route exact path='/' component={HomePage}/>
      <Route path='/audio' component={ProAudioPage}/>
      <Route path='/drums' component={DrumsPage}/>
      {/* <Route path='/freelessons' component={FreeLessonsPage}/> */}
      <Route path='/lessons' component={LessonsPage}/>
      <Route path='/hours' component={StoreInfoPage}/>
      <Route path='/links' component={StoreInfoPage}/>
      <Route path='/login' component={LoginPage}/>
      <Route path='/privacy' component={StoreInfoPage}/>
      {/* <Route path='/products/:productId' component={ProductPage}/>
      <Route path='/products' component={ProductListPage}/> */}
      <Route path='/repair' component={RepairPage}/>
      <Route path='/returns' component={StoreInfoPage}/>
      <Route path='/roadshow' component={RoadShowPage}/>
      <Route path='/staff' component={StoreInfoPage}/>
    </Switch>
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js